'use strict';

function warn(method, error) {
  console.warn('Error on calling localStorage.' + method + '\n', error.stack);
}

module.exports = {
  getItem(...args) {
    try {
      return localStorage.getItem.apply(localStorage, args);
    } catch (error) {
      warn('getItem', error);
    }
  },

  setItem(...args) {
    try {
      localStorage.setItem.apply(localStorage, args);
    } catch (error) {
      warn('setItem', error);
    }
  },

  removeItem(...args) {
    try {
      localStorage.removeItem.apply(localStorage, args);
    } catch (error) {
      warn('removeItem', error);
    }
  }
};


/** WEBPACK FOOTER **
 ** ./utils/SafeLocalStorage.js
 **/